import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Nav, NavItem } from "reactstrap";
import MultiComments from "../../components/Common/MultiComments";
// Import Breadcrumb
import Breadcrumbs from "../../components/Layout/Breadcrumb";

import ScrollUp from "../../components/ScrollUpDown/ScrollUp";
import ScrollDown from "../../components/ScrollUpDown/ScrollDown";

import { useTranslation } from "react-i18next";

import NavItems from "./NavItems";

import { Row, Col, Card, CardBody } from "reactstrap";

import usersService from "../../services/users.service";
//Email
import { setDraftEmailData } from "../../store/mails/actions";
import EmailButton from "../Email/components/EmailButton";
import { draftmailProps } from "../Email/components/type";
import { useDispatch } from "react-redux";
const EditUserComments = (props: any) => {
  const { t } = useTranslation();
  document.title = `${t("User details")} - ${t("Comments")} | ${process.env.REACT_APP_NAME}`;
  const breadcrumbItems = [
    {
      url: "/dashboard",
      label: t("Dashboard"),
      active: false,
    },
    {
      url: "/users/all-users",
      label: t("Users"),
      active: false,
    },
    {
      url: "#",
      label: t("Update user"),
      active: true,
    },
  ];
  const { id, user_id } = useParams();
  const [userInfo,setUserInfo] = useState<any>({});
  const dispatch = useDispatch();
  const [commentToIDs, setCommentToIDs] = useState<any>([]);

  const getUser = async () => {
    try {
      const res = (await usersService.getUser({
        id: id,
        user_id: user_id,
      })) as any;
     
      if (res?.data?.status === "success") {
        let userData = res.data.data[0];
        setUserInfo(userData)
        setCommentToIDs([
          {
            value: userData.id,
            label: userData?.first_name + " " + userData?.last_name,
            selected: true,
          },
          {
            value:
              userData.company === 0
                ? userData.file_manager
                : userData.company_file_manager,
            label: "File manager",
          },
          {
            value:
              userData.company === 0 ? null : userData.company_contact_person,
            label: "Contact person (HR)",
          },
        ]);
      } else {
      }
    } catch (err) {}
  };

  useEffect(() => {
    getUser();
  }, []);


  const composeMail = () => {
    const user = {
      label: `${userInfo?.first_name} ${userInfo?.last_name}`,
      value: userInfo?.email,
    };
    const draftMail: draftmailProps = {
      title: t("New Message"),
      filters: {},
      openMailBox: 1,
      to: [user],
    };
    dispatch(setDraftEmailData(draftMail));
  };

  return (
    <React.Fragment>
      <ScrollUp />
      <ScrollDown />

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            breadcrumbTitle={t("Update user")}
            breadcrumbItems={breadcrumbItems}
            endAdornment={
              <>
              <EmailButton handlerCompose={() => composeMail()} />
              </>
            }
          />

          <NavItems id={id} user_id={user_id} />

          <Row>
            <Col xl="12">
              <Card className="border-top-0 rounded-0 rounded-bottom">
                <CardBody>
                  <Row>
                    <MultiComments
                      moduleData={{
                        module_app_id: 1,
                        module_main_id: id,
                        module_sub_id: user_id,
                        section_id: 0,
                      }}
                      commentForIDs={commentToIDs}
                      fetchData={true}
                      isOpen={false}
                    />
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditUserComments;
